import { useDispatch, useSelector } from "react-redux";
import { airlineIcon } from "../components/airlineimages";
import SearchModule from "../components/searchmodules/SearchModule";
import spicejet from "../libs/images/AirlineLogo/0B.gif";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  search_flights_data,
  showAlertMessage,
} from "../components/server/api";
import {
  setBottomSticky,
  setBottomStickyData,
  setBottomStickyData2,
  setFilterData,
  setSearchFlights,
} from "../redux/global/global.action";
import { useState } from "react";
import Loader from "../components/loader/Loader";
import { Link } from "react-router-dom";
const moment = require("moment");

const options1 = {
  nav: false,
  dots: true,

  loop: true,
  responsive: {
    0: {
      items: 3,
    },
    420: {
      items: 4,
    },

    600: {
      items: 5,
    },
    900: {
      items: 5,
    },
    1200: {
      items: 6,
    },
  },
};

export const set_flight_fare = (fare, airlinecode = "", airlines = []) => {
  const {
    BaseFare,
    Tax,
    OtherCharges,
    ServiceFee,
    AdditionalTxnFeepub,
    AirlineTransFee,
    PublishedFare,
  } = fare;
  // return parseFloat(PublishedFare);
  const obj = airlines.find((obj) => obj.AirlineCode == airlinecode);
  // console.log('airlinecode - '+airlinecode,obj);
  if (obj) {
    if (obj.markup_status == 2) {
      return parseFloat(PublishedFare) - parseFloat(obj ? obj.markup_price : 0);
    } else {
      return parseFloat(PublishedFare) + parseFloat(obj ? obj.markup_price : 0);
    }
  } else {
    return parseFloat(PublishedFare);
  }

  //    return BaseFare + Tax + OtherCharges + ServiceFee + AdditionalTxnFeepub + AirlineTransFee;
};

export const flight_dateTimeFormat = (timestamp, short = false) => {
  return moment(timestamp).format("DD/MM HH:mm");

  if (short) {
    return moment(timestamp).format("ddd MMM DD");
  } else {
    return moment(timestamp).format("ddd MMM DD hh:mm A");
  }
};

const OriginDestination = (props) => {
  const search_data = useSelector((state) => state.global.search_data);
  const flight_data = useSelector((state) => state.global.flights_list);
  const { Segments, ResultIndex } = props;
  var duration = 0;
  return (
    <div class="flight-details">
      <div class="flight-time">
        {Segments.length
          ? Segments.map((datas) => {
              return datas.map((airport, index) => {
                duration += airport.Duration;
                // if(index===0 || (index===(parseInt(Segments.length) - 1))){
                return (
                  <>
                    <div class="flight-time-item take-off d-flex">
                      <div class="flex-shrink-0 mr-2">
                        <i class="la la-plane"></i>
                      </div>
                      <div>
                        <h3 class="card-title font-size-15 font-weight-medium mb-0">
                          {airport.Origin.Airport.AirportCode}
                        </h3>
                        <p class="card-meta font-size-14">
                          {flight_dateTimeFormat(airport.Origin.DepTime)}
                        </p>
                      </div>
                    </div>
                    <div class="flight-time-item landing d-flex">
                      <div class="flex-shrink-0 mr-2">
                        <i class="la la-plane"></i>
                      </div>
                      <div>
                        <h3 class="card-title font-size-15 font-weight-medium mb-0">
                          {airport.Destination.Airport.AirportCode}
                        </h3>
                        <p class="card-meta font-size-14">
                          {flight_dateTimeFormat(airport.Destination.ArrTime)}
                        </p>
                      </div>
                    </div>
                  </>
                );
                // }
                // if (Segments.length === index + 1) {
                //     return (
                //         <>
                //         <div class="flight-time-item landing d-flex">
                //             <div class="flex-shrink-0 mr-2">
                //                 <i class="la la-plane"></i>
                //             </div>
                //             <div>
                //                 <h3 class="card-title font-size-15 font-weight-medium mb-0">{airport.Destination.Airport.AirportCode}</h3>
                //                 <p class="card-meta font-size-14">{flight_dateTimeFormat(airport.Destination.ArrTime)}</p>
                //             </div>
                //         </div>
                //         </>
                //     )
                // }else{
                //     return ''
                // }
              });
            })
          : ""}
      </div>
      <p class="font-size-14 text-center pt-2">
        <span class="color-text-2 mr-1">Total Time:</span>
        {duration} Minutes
      </p>
      <p class="font-size-14 text-center pt-2">
        <Link
          to={{
            pathname:
              "flight-details/" +
              search_data.TokenId +
              "/" +
              flight_data.TraceId +
              "/" +
              ResultIndex,
          }}
        >
          View Flight Details
        </Link>
      </p>
      <p class="font-size-14 text-center pt-2">
        <Link
          to={{
            pathname:
              "book-flight/" +
              search_data.TokenId +
              "/" +
              flight_data.TraceId +
              "/" +
              ResultIndex,
          }}
        >
          Book Flight
        </Link>
      </p>
    </div>
  );
};

const FlightFilters = (props) => {
  const [filters, setFilter] = useState({
    airlines: [],
    stops: [],
  });
  const dispatch = useDispatch();
  const flight_data = useSelector((state) => state.global.flights_list);
  const airlines = useSelector((state) => state.global.airlines);
  const search_data = useSelector((state) => state.global.search_data);
  var airlines_arr = [];

  var selectedairlineArr = [];
  var selectedFlightStop = [];

  const handleChange = (e) => {
    if (e.target.name === "AirlineCode") {
      const air_code = e.target.value.trim();
      if (e.target.checked) {
        selectedairlineArr.push(air_code);
      } else {
        const index = selectedairlineArr.indexOf(air_code);
        if (index > -1) {
          selectedairlineArr.splice(index, 1);
        }
      }
      if (flight_data.status) {
        if (selectedairlineArr.length) {
          const myArrayFiltered = flight_data.Results[0].filter((el) =>
            selectedairlineArr.includes(el.AirlineCode)
          );
          var myArrayFiltered2 = [];
          if (search_data.journeyType == 2) {
            myArrayFiltered2 = flight_data.Results[1].filter((el) =>
              selectedairlineArr.includes(el.AirlineCode)
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...myArrayFiltered, ...myArrayFiltered2],
              Results2: [...myArrayFiltered2],
            })
          );
        } else {
          dispatch(
            setFilterData({
              ...flight_data,
              status: false,
              Results: [],
              Results2: [],
            })
          );
        }
      } else {
        dispatch(
          setFilterData({
            ...flight_data,
            status: false,
            Results: [],
            Results2: [],
          })
        );
      }
    }

    if (e.target.name === "flight_stop") {
      const air_stop = e.target.value.trim();
      if (e.target.checked) {
        selectedFlightStop.push(air_stop);
        if (air_stop == "non_stop") {
          var non_stop_list = flight_data.Results[0].filter(
            (el) => el.Segments[0].length == 1
          );
          var non_stop_list2 = [];
          if (search_data.journeyType == 2) {
            non_stop_list2 = flight_data.Results[1].filter(
              (el) => el.Segments[0].length == 1
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...non_stop_list, ...non_stop_list2],
              Results2: [...non_stop_list2],
            })
          );
        } else if (air_stop == "one_stop") {
          var non_stop_list1 = flight_data.Results[0].filter(
            (el) => el.Segments[0].length == 2
          );
          var non_stop_list12 = [];
          if (search_data.journeyType == 2) {
            non_stop_list12 = flight_data.Results[1].filter(
              (el) => el.Segments[0].length == 2
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...non_stop_list1, ...non_stop_list12],
              Results2: [...non_stop_list12],
            })
          );
        }
      } else {
        // const index = selectedFlightStop.indexOf(air_stop);
        // if (index > -1) {
        //     selectedFlightStop.splice(index, 1);
        // }
      }
      // const myArrayFiltered2 = flight_data.Results[0].filter(el => selectedairlineArr.includes(el.AirlineCode))
    }

    // IsRefundable

    if (e.target.name === "flight_type") {
      const air_type = e.target.value.trim();
      if (e.target.checked) {
        if (air_type == "gds") {
          var gds_list = flight_data.Results[0].filter(
            (el) => el.IsLCC === false
          );
          var gds_list2 = [];
          if (search_data.journeyType == 2) {
            gds_list2 = flight_data.Results[1].filter(
              (el) => el.IsLCC === false
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...gds_list, ...gds_list2],
              Results2: [...gds_list2],
            })
          );
        } else if (air_type == "non_gds") {
          var gds_list = flight_data.Results[0].filter((el) => el.IsLCC);
          var gds_list2 = [];
          if (search_data.journeyType == 2) {
            gds_list2 = flight_data.Results[1].filter((el) => el.IsLCC);
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...gds_list, ...gds_list2],
              Results2: [...gds_list2],
            })
          );
        }
      } else {
      }
    }

    if (e.target.name === "refund_type") {
      const refund_type = e.target.value.trim();
      if (e.target.checked) {
        if (refund_type == "refund") {
          var refund_list = flight_data.Results[0].filter(
            (el) => el.IsRefundable === true
          );
          var refund_list2 = [];
          if (search_data.journeyType == 2) {
            refund_list2 = flight_data.Results[1].filter(
              (el) => el.IsRefundable === true
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...refund_list, ...refund_list2],
              Results2: [...refund_list2],
            })
          );
        } else if (refund_type == "non_refund") {
          var refund_list1 = flight_data.Results[0].filter(
            (el) => el.IsRefundable === false
          );
          var refund_list12 = [];
          if (search_data.journeyType == 2) {
            refund_list12 = flight_data.Results[1].filter(
              (el) => el.IsRefundable === false
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...refund_list1, ...refund_list12],
              Results2: [...refund_list12],
            })
          );
        }
      } else {
      }
    }
  };

  return (
    <div class="col-lg-4">
      <div class="sidebar mt-0">
        <div class="sidebar-widget">
          <h3 class="title stroke-shape">Popular Filters</h3>
          <div class="sidebar-widget-item">
            {flight_data.status &&
            flight_data.hasOwnProperty("Results") &&
            flight_data.Results &&
            flight_data.Results.length > 0
              ? flight_data.Results.map((rs) => {
                  //  debugger;
                  if (!rs.length) {
                    return "";
                  } else {
                    return rs.map((results) => {
                      if (!airlines_arr.includes(results.AirlineCode)) {
                        airlines_arr.push(results.AirlineCode);
                        return (
                          <div class="custom-checkbox">
                            <input
                              type="radio"
                              name="AirlineCode"
                              onChange={handleChange}
                              value={results.AirlineCode}
                              id={results.AirlineCode}
                            />
                            <label for={results.AirlineCode}>
                              {results.Segments[0][0].Airline.AirlineName}{" "}
                            </label>{" "}
                            <span class="flight-price">
                              ₹{" "}
                              {set_flight_fare(
                                results.Fare,
                                results.AirlineCode,
                                airlines
                              )}
                            </span>
                          </div>
                        );
                      } else {
                        return "";
                      }
                    });
                  }
                })
              : ""}
          </div>
        </div>

        <div class="sidebar-widget">
          <h3 class="title stroke-shape">Flight Stops</h3>
          <div class="sidebar-widget-item">
            <div class="custom-checkbox">
              <input
                type="radio"
                value="non_stop"
                onChange={handleChange}
                name="flight_stop"
                id="flightStop3"
              />
              <label for="flightStop3"> Non Stop</label>
            </div>
            <div class="custom-checkbox">
              <input
                type="radio"
                value="one_stop"
                onChange={handleChange}
                name="flight_stop"
                id="flightStop1"
              />
              <label for="flightStop1"> 1 Stop</label>
            </div>
          </div>
        </div>

        <div class="sidebar-widget">
          <h3 class="title stroke-shape">Flight Type</h3>
          <div class="sidebar-widget-item">
            <div class="custom-checkbox">
              <input
                type="radio"
                value="gds"
                onChange={handleChange}
                name="flight_type"
              />
              <label for="flightStop3"> GDS</label>
            </div>
            <div class="custom-checkbox">
              <input
                type="radio"
                value="non_gds"
                onChange={handleChange}
                name="flight_type"
              />
              <label for="flightStop1"> Non GDS</label>
            </div>
          </div>
        </div>

        <div class="sidebar-widget">
          <h3 class="title stroke-shape">Refund</h3>
          <div class="sidebar-widget-item">
            <div class="custom-checkbox">
              <input
                type="radio"
                value="refund"
                onChange={handleChange}
                name="refund_type"
              />
              <label for="flightStop3"> Refundable</label>
            </div>
            <div class="custom-checkbox">
              <input
                type="radio"
                value="non_refund"
                onChange={handleChange}
                name="refund_type"
              />
              <label for="flightStop1"> Non Refundable</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FlightComponent = (props) => {
  const results = props;
  const dispatch = useDispatch();
  const airlines = useSelector((state) => state.global.airlines);

  const set_sticky = (data = {}, cls = "jana") => {
    console.log("set sticky", data);
    dispatch(setBottomSticky(1));
    if (cls == "jana") {
      dispatch(setBottomStickyData({ ...data }));
    } else if (cls == "aana") {
      dispatch(setBottomStickyData2({ ...data }));
    }
  };
  return (
    <div class="col-lg-6">
      <div class="card-item flight-card flight--card card-item-list card-item-list-2">
        <div class="card-body">
          <div class="card-top-title d-flex justify-content-between">
            <div class="spice">
              <img
                src={`../AirlineLogo/${results.AirlineCode}.gif`}
                alt={results.AirlineCode}
              />
              <h3 class="card-title font-size-17 spice-title">
                {results.Segments[0][0].Airline.AirlineName}
              </h3>
            </div>
            <div>
              <div class="text-right flight-price1">
                <h6 class="font-weight-bold color-text">
                  ₹
                  {set_flight_fare(results.Fare, results.AirlineCode, airlines)}
                </h6>
                {/* <input type="radio" name="spi" id={props.roundtrip?props.compid:false} class="rad" value={props.roundtrip?props.compid:false} /> */}
                <input
                  onChange={() =>
                    set_sticky(
                      props,
                      props.roundtrip && props.hasOwnProperty("compid")
                        ? props.compid
                        : "jana"
                    )
                  }
                  type="radio"
                  name={
                    props.roundtrip && props.hasOwnProperty("compid")
                      ? props.compid
                      : "jana"
                  }
                  value="spi"
                  class="rad"
                />
              </div>
            </div>
          </div>
          <OriginDestination {...props} />
        </div>
      </div>
    </div>
  );
};

export const StickyBottom = (props) => {
  const sticky_data = useSelector((state) => state.global.sticky_data);
  const sticky_data2 = useSelector((state) => state.global.sticky_data2);
  const flight_token = useSelector((state) => state.global.flight_token);

  const airlines = useSelector((state) => state.global.airlines);
  const fare1 = set_flight_fare(
    sticky_data.Fare,
    sticky_data.AirlineCode,
    airlines
  );
  const fare2 = sticky_data2.hasOwnProperty("AirlineCode")
    ? set_flight_fare(sticky_data2.Fare, sticky_data2.AirlineCode, airlines)
    : 0;
  const search_data = useSelector((state) => state.global.search_data);
  const flight_data = useSelector((state) => state.global.flights_list);
  const { Segments } = sticky_data;
  var duration = 0;
  return (
    <div class="sticky-bar">
      <div class="container">
        <div class="row">
          
          <div
            class={
              sticky_data2.hasOwnProperty("AirlineCode") ? "col-4" : "col-8"
            }
          >
            <div class="stickyFlightDtl appendRight15">
              
              <p class="whiteText appendBottom12">
                Departure ・ {sticky_data.AirlineCode}{" "}
              </p>
              <div class="makeFlex spaceBetween">
                <div class="makeFlex">
                  <span class="">
                    <span class="arln-logo logo1"></span>
                  </span>
                  <div class="appendLeft10">
                    {Segments.length
                      ? Segments.map((datas) => {
                          return datas.map((airport) => {
                            duration += airport.Duration;
                            return (
                              <>
                                <p class="whiteText blackFont fontSize16 appendBottom4">
                                  ({airport.Origin.Airport.AirportCode}){" "}
                                  {flight_dateTimeFormat(
                                    airport.Origin.DepTime
                                  )}{" "}
                                  → ({airport.Destination.Airport.AirportCode}){" "}
                                  {flight_dateTimeFormat(
                                    airport.Destination.ArrTime
                                  )}
                                </p>
                              </>
                            );
                          });
                        })
                      : ""}
                    {/* <Link
                      className="skyBlueText fontSize12 pointer "
                      to={{
                        pathname:
                          "flight-details/" +
                          search_data.TokenId +
                          "/" +
                          flight_data.TraceId +
                          "/" +
                          sticky_data.ResultIndex,
                      }}
                    > */}
                      <Link
                        style={{
                          color:'#5d646d'
                        }}
                            to={{
                              pathname:
                                "flight-details/" +
                                flight_token.TokenId +
                                "/" +
                                flight_data.TraceId +
                                "/" +
                                sticky_data.ResultIndex,
                            }}
                          >
                      Flight Details
                    </Link>
                  </div>
                </div>
                <span class="whiteText blackFont fontSize16">₹ {fare1}</span>
              </div>
            </div>
          </div>

          {sticky_data2.hasOwnProperty("AirlineCode") ? (
            <div class="col-4">
              <div class="stickyFlightDtl appendRight15">
                <p class="whiteText appendBottom12">
                  Return ・ {sticky_data2.AirlineCode}{" "}
                </p>
                <div class="makeFlex spaceBetween">
                  <div class="makeFlex">
                    <span class="">
                      <span class="arln-logo logo1"></span>
                    </span>
                    <div class="appendLeft10">
                      {Segments.length
                        ? Segments.map((datas) => {
                            return datas.map((airport) => {
                              duration += airport.Duration;
                              return (
                                <>
                                  <p class="whiteText blackFont fontSize16 appendBottom4">
                                    ({airport.Origin.Airport.AirportCode}){" "}
                                    {flight_dateTimeFormat(
                                      airport.Origin.DepTime
                                    )}{" "}
                                    → ({airport.Destination.Airport.AirportCode}
                                    ){" "}
                                    {flight_dateTimeFormat(
                                      airport.Destination.ArrTime
                                    )}
                                  </p>
                                </>
                              );
                            });
                          })
                        : ""}
                      <Link
                        className="skyBlueText fontSize12 pointer "
                        to={{
                          pathname:
                            "flight-details/" +
                            flight_token.TokenId +
                            "/" +
                            flight_data.TraceId +
                            "/" +
                            sticky_data2.ResultIndex,
                        }}
                      >
                        Flight Details
                      </Link>
                    </div>
                  </div>
                  <span class="whiteText blackFont fontSize16">₹ {fare2}</span>
                </div>
              </div>

            </div>
          ) : (
            ""
          )}

          <div class="col-4 flight-button">
            <div class="fare-price font-size-26">
              ₹{parseFloat(fare1) + parseFloat(fare2)}/-
            </div>

            <div class="product-details-action">
              {/* <Link
                className="theme-btn1 text-center"
                to={{
                  pathname:
                    "book-flight/" +
                    search_data.TokenId +
                    "/" +
                    flight_data.TraceId +
                    "/" +
                    sticky_data.ResultIndex,
                }}
              > */}
               <Link
                style={{
                  color:'#5d646d'
                }}
                    to={{
                      pathname:
                        "round-flight-details/" +
                        flight_token.TokenId +
                        "/" +
                        flight_data.TraceId +
                        "/" +
                        sticky_data.ResultIndex+
                        "/" +
                        sticky_data2.ResultIndex
                    }}

                    className="theme-btn1 text-center"
                  >
                Book Now
              </Link>
              {/* <a href="flight-booking.html" class="theme-btn1 text-center"><span>Book Now</span></a> */}
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

const Home = (props) => {
  const dispatch = useDispatch();
  const flight_data = useSelector((state) => state.global.flights_list);
  const calender_fare = useSelector((state) => state.global.calender_fare);
  const search_data = useSelector((state) => state.global.search_data);
  const [loadcircle, setLoadCircle] = useState(0);
  const filter_data = useSelector((state) => state.global.search_filters);
  const showBottomSticky = useSelector(
    (state) => state.global.showBottomSticky
  );
  const search_flight_by_calender_fare = (date) => {
    const arr = {
      ...search_data,
      journeyType: 1,
      departure_date: moment(date).format("YYYY-MM-DD"),
    };
    setLoadCircle(1);
    search_flights_data(arr).then((res) => {
      setLoadCircle(0);
      dispatch(setSearchFlights(res));
      if (res.status) {
      } else {
        showAlertMessage("oops", res.message, false, true);
      }
    });
  };

  const count_flights = (flig) => {
    var total = 0;
    if (flig.status) {
      // debugger;
      if (flig.hasOwnProperty("Results")) {
        const Alength = flig.Results.length;
        for (let i = 0; i < Alength; i++) {
          const element = flig.Results[i].length;
          total += element;
        }
      }

      return total + " Flights found!";
    } else {
      return "";
    }
  };

  return (
    <>
      <SearchModule />

      {loadcircle ? <Loader /> : ""}
      {flight_data.status ? (
        <section class="card-area section--padding">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="filter-wrap margin-bottom-30px">
                  <div class="filter-top d-flex align-items-center justify-content-between pb-4">
                    <div>
                      <h3 class="title font-size-24">
                        {flight_data.status ? count_flights(flight_data) : ""}
                      </h3>
                      <p class="font-size-14">
                        <span class="mr-1 pt-1">Book with confidence:</span>No
                        flight booking fees
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row all-bot">
              <FlightFilters />

              <div class="col-lg-8">
                <div
                  class="MultiCarousel"
                  data-items="1,3,5,6"
                  data-slide="1"
                  id="MultiCarousel"
                  data-interval="1000"
                >
                  <div class="MultiCarousel-inner">
                    <OwlCarousel
                      className="owl-theme owl-carousel owl-simple owl-light owl-nav-inside"
                      {...options1}
                    >
                      {calender_fare.status && calender_fare.searchResults
                        ? calender_fare.searchResults.map((res) => {
                            return (
                              <div
                                onClick={() =>
                                  search_flight_by_calender_fare(
                                    res.DepartureDate
                                  )
                                }
                                class="item"
                                key={res.DepartureDate}
                              >
                                <div class="pad15">
                                  <p class="Weak-date">
                                    {flight_dateTimeFormat(
                                      res.DepartureDate,
                                      true
                                    )}
                                  </p>
                                  <p class="slide-price">₹ {res.Fare}</p>
                                </div>
                              </div>
                            );
                          })
                        : ""}
                    </OwlCarousel>
                  </div>
                </div>

                <div class="row">
                  {filter_data.status &&
                  filter_data.hasOwnProperty("Results") &&
                  filter_data.Results
                    ? filter_data.Results.map((results, index) => {
                        return (
                          <>
                            <FlightComponent
                              {...results}
                              roundtrip={
                                index in filter_data.Results2 ? true : false
                              }
                              compid="jana"
                            />
                            {index in filter_data.Results2 ? (
                              <FlightComponent
                                {...filter_data.Results2[index]}
                                roundtrip={true}
                                compid="aana"
                              />
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })
                    : flight_data.status &&
                      flight_data.hasOwnProperty("Results") &&
                      flight_data.Results
                    ? flight_data.Results.length > 1
                      ? flight_data.Results.map((results, parentindex) => {
                          return results.map((res, index) => {
                            if (parentindex == 0) {
                              return (
                                <>
                                  <FlightComponent
                                    {...res}
                                    roundtrip={true}
                                    compid="jana"
                                  />

                                  {index in
                                  flight_data.Results[parentindex + 1] ? (
                                    <FlightComponent
                                      {...flight_data.Results[parentindex + 1][
                                        index
                                      ]}
                                      roundtrip={true}
                                      compid="aana"
                                    />
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            } else {
                              return "";
                            }
                          });
                        })
                      : flight_data.Results.map((results) => {
                          return results.map((res) => {
                            return (
                              <FlightComponent roundtrip={false} {...res} />
                            );
                          });
                        })
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
      {showBottomSticky ? <StickyBottom /> : ""}
      {/* <StickyBottom /> */}
    </>
  );
};

export default Home;
